import { useSuperAdminPartnerStore } from "../../stores/superadmin/superadminpartner";
import pen from "../../assets/icons/edit.svg";
import trash from "../../assets/icons/trash.svg";
import clip from "../../assets/icons/paperclip.svg";
import { getMandate } from "../../services/Api/partnerSuscriptionService";
import "../../css/animations.css";
import DeletePartnerSuperAdmin from "./modal/DeletePartnerSuperAdmin";
import { useSuperAdminCreatePartnerStore } from "../../stores/superadmin/createPartner";
import CreatePartner from "./modal/CreatePartner";
import { dateFormat } from "../../services/Utils/functionService";
import { useNavigate } from "react-router-dom";
import AddUser from "./modal/AddUser";
import {
  downloadPdfInvoice,
  getInvoices,
} from "../../services/Api/superadminService";
import { useState } from "react";
import pdf from "../../assets/icons/pdf.png";
import image from "../../assets/icons/image-plus.svg";
import addUserIcon from "../../assets/icons/user-plus.svg";
import AddLogo from "./modal/AddLogo";
import { showToastError } from "../../services/Toasts/toasts";

const SuperAdminPartnerTable = ({ openModal, closeModal }: any) => {
  // Store
  const { partners, setPartnerId, setModePartner, invoices, setInvoices } =
    useSuperAdminPartnerStore();
  const { openDetails, setOpenDetails, displayDiv, setDisplayDiv } =
    useSuperAdminCreatePartnerStore();

  // Hook
  const navigate = useNavigate();

  const downloadMandate = (idPartnerSubscription: number) => {
    getMandate(idPartnerSubscription)
      .then((response) => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "mandat.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } else {
          console.error("La réponse est undefined");
        }
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  const handleInvoiceByPartner = (idPartner: number) => {
    getInvoices(idPartner)
      .then((res) => {
        setInvoices(res.data);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  const [idPartner, setIdPartner] = useState(0);
  const [open, setOpen] = useState(false);

  const handleOpen = (id: number) => {
    if (id === idPartner && open) {
      setOpen(false);
      setIdPartner(0);
      return;
    }
    if (id === idPartner) {
      setOpen(!open);
    } else {
      setOpen(true);
    }
    setIdPartner(id);
  };

  const handleDownload = (idPartner: number, idInvoice: number) => {
    downloadPdfInvoice(idPartner, idInvoice)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    <div className="w-full h-full">
      {/* Header avec informations et actions */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
          <div className="flex items-center gap-4">
          </div>
          
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600 font-medium">
              Total : <span className="text-blue-600 font-semibold">{partners.length}</span> partenaire{partners.length > 1 ? 's' : ''}
            </span>
          </div>
        </div>
      </div>

      {/* Table des partenaires */}
      <div className="w-full overflow-y-auto max-h-[calc(85vh-10rem)]">
        {/* En-têtes de colonnes */}
        <div className="w-full grid grid-cols-12 px-6 py-4 bg-gray-50 border-b border-gray-200 text-sm font-semibold text-gray-700 sticky top-0">
          <div className="col-span-1">ID</div>
          <div className="col-span-3">Nom du Partenaire</div>
          <div className="col-span-2">Date de début</div>
          <div className="col-span-2">Type de licence</div>
          <div className="col-span-1">Statut</div>
          <div className="col-span-1">Mandat</div>
          <div className="col-span-2">Actions</div>
        </div>

        {/* Corps de la table */}
        <div className="w-full">
          {partners.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun partenaire trouvé</h3>
              <p className="text-gray-500">Vous n'avez pas encore créé de partenaire.</p>
            </div>
          ) : (
            partners.map((partner) => (
              <div key={partner.id} className="w-full">
                {/* Ligne principale du partenaire */}
                <div className="w-full hover:bg-blue-50 transition-all duration-200 border-b border-gray-100">
                  <div className="grid grid-cols-12 px-6 py-4">
                    {/* ID */}
                    <div className="col-span-1 flex items-center">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                        #{partner.id}
                      </span>
                    </div>

                    {/* Nom du partenaire */}
                    <div className="col-span-3 flex items-center">
                      <div className="font-medium text-gray-900">{partner.name}</div>
                    </div>

                    {/* Date de début */}
                    <div className="col-span-2 flex items-center">
                      <div className="text-gray-600 text-sm">{dateFormat(partner.startDate)}</div>
                    </div>

                    {/* Type de licence */}
                    <div className="col-span-2 flex items-center">
                      <div className="text-gray-600 text-sm">{partner.subscription}</div>
                    </div>

                    {/* Statut */}
                    <div className="col-span-1 flex items-center">
                      {partner.isSubscriptionEnabled == 1 ? (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          ✅ Actif
                        </span>
                      ) : (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                          ❌ Inactif
                        </span>
                      )}
                    </div>

                    {/* Mandat */}
                    <div className="col-span-1 flex items-center">
                      {partner.mandate ? (
                        <button
                          className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg transition-colors duration-200"
                          onClick={() => downloadMandate(partner?.idPartnerSubscription)}
                          title="Télécharger le mandat"
                        >
                          <img src={clip} alt="mandat" className="w-4 h-4" />
                        </button>
                      ) : (
                        <span className="text-gray-400 text-xs">-</span>
                      )}
                    </div>

                    {/* Actions */}
                    <div className="col-span-2 flex items-center gap-2">
                      <button
                        className="p-2 bg-gray-100 hover:bg-blue-100 rounded-lg transition-colors duration-200"
                        onClick={() => navigate(`/partner/${partner?.id}/admin/users/partner`)}
                        title="Administration"
                      >
                        <span className="text-xs font-medium text-gray-700">Admin</span>
                      </button>
                      <button
                        className="p-2 bg-gray-100 hover:bg-blue-100 rounded-lg transition-colors duration-200"
                        onClick={() => navigate(`/partner/${partner?.id}/customers`)}
                        title="Gestion des clients"
                      >
                        <span className="text-xs font-medium text-gray-700">Manager</span>
                      </button>
                    </div>
                  </div>

                  {/* Actions supplémentaires */}
                  <div className="px-6 pb-4 flex items-center gap-2">
                    <button
                      className="p-2 bg-gray-100 hover:bg-green-100 rounded-lg transition-colors duration-200"
                      onClick={() => openModal(
                        <AddUser
                          idPartner={partner.id}
                          closeModal={closeModal}
                          namePartner={partner.name}
                        />
                      )}
                      title="Ajouter un utilisateur"
                    >
                      <img src={addUserIcon} alt="ajouter utilisateur" className="w-4 h-4" />
                    </button>
                    <button
                      className="p-2 bg-gray-100 hover:bg-purple-100 rounded-lg transition-colors duration-200"
                      onClick={() => openModal(
                        <AddLogo
                          idPartner={partner.id}
                          closeModal={closeModal}
                          namePartner={partner.name}
                        />
                      )}
                      title="Ajouter un logo"
                    >
                      <img src={image} alt="ajouter logo" className="w-4 h-4" />
                    </button>
                    <button
                      className="p-2 bg-gray-100 hover:bg-yellow-100 rounded-lg transition-colors duration-200"
                      onClick={() => {
                        setPartnerId(partner.id);
                        setDisplayDiv(true);
                        setModePartner("edit");
                        setOpenDetails(true);
                      }}
                      title="Modifier le partenaire"
                    >
                      <img src={pen} alt="modifier" className="w-4 h-4" />
                    </button>
                    <button
                      className="p-2 bg-gray-100 hover:bg-red-100 rounded-lg transition-colors duration-200"
                      onClick={() => openModal(
                        <DeletePartnerSuperAdmin
                          idPartner={partner.id}
                          closeModal={closeModal}
                        />
                      )}
                      title="Supprimer le partenaire"
                    >
                      <img src={trash} alt="supprimer" className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                {/* Section des factures (expandable) */}
                {idPartner === partner.id && (
                  <div className="mx-6 mb-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 rounded-t-lg">
                      <h4 className="text-sm font-semibold text-gray-700">Factures du partenaire</h4>
                    </div>
                    
                    {/* En-têtes des factures */}
                    <div className="grid grid-cols-7 px-4 py-3 text-xs font-medium text-gray-600 border-b border-gray-200">
                      <div></div>
                      <div>Date</div>
                      <div>N° Facture</div>
                      <div>Remise</div>
                      <div>TVA</div>
                      <div>Montant HT</div>
                      <div>Montant TTC</div>
                    </div>

                    {/* Liste des factures */}
                    <div className="max-h-44 overflow-y-auto">
                      {invoices.length > 0 ? (
                        invoices.map((invoice) => (
                          <div
                            key={invoice.id}
                            className="grid grid-cols-7 px-4 py-2 text-xs border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200"
                          >
                            <div className="flex items-center">
                              <button
                                onClick={() => handleDownload(partner.id, invoice.id)}
                                className="p-1 bg-blue-100 hover:bg-blue-200 rounded transition-colors duration-200"
                                title="Télécharger la facture"
                              >
                                <img src={pdf} alt="pdf" className="w-3 h-4" />
                              </button>
                            </div>
                            <div className="text-gray-600">{dateFormat(invoice.date)}</div>
                            <div className="text-gray-600">{invoice.invoiceNumber}</div>
                            <div className="text-gray-600">{invoice.discountAmount}</div>
                            <div className="text-gray-600">{invoice.vatAmount}</div>
                            <div className="text-gray-600">{invoice.grossAmount}</div>
                            <div className="text-gray-600">{invoice.netAmount}</div>
                          </div>
                        ))
                      ) : (
                        <div className="col-span-7 text-center py-8 text-gray-500 text-sm">
                          Aucune facture disponible
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      {/* Modal de création/édition */}
      {displayDiv && openDetails && <CreatePartner />}
    </div>
  );
};

export default SuperAdminPartnerTable;
